import React from 'react'
import styled from 'styled-components'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import presets from "../utils/presets"
import {rhythm} from "../utils/typography"

const BlogGallery = styled.div`
  display: flex;
  flex-flow: row wrap;
  width:calc(100% - ${rhythm(2)});
  max-width:${rhythm(28)};
  margin:0 auto;
  ${presets.shadowMed}

  display: flex;
  align-items: center;
  justify-content: center;
  /* You can set flex-wrap and
  flex-direction individually */
  flex-direction: row;
  flex-wrap: wrap;
  /* Or do it all in one line
  with flex flow */
  flex-flow: row wrap;
  /* tweak where items line
  up on the row
  valid values are: flex-start,
  flex-end, space-between,
  space-around, stretch */
  align-content: flex-end;
`

export default BlogGallery



// WEBPACK FOOTER //
// ./src/com/BlogGallery.js